var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid-col",class:_vm.classname(),style:({backgroundColor:_vm.backgroundColor,backgroundImage: _vm.backgroundImage ? `url(${_vm.backgroundImage})` : 'none'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }